import React from 'react';
import PropTypes from 'prop-types';
import {
    InnerWrapper,
    SubstitutePlayerWrapper,
    CustomPlayerCellContainer,
    PositionWrapper
} from '../BoxscoreTeamTable.style';
import PlayerNameWithNote from './PlayerNameWithNote';
import PlayerLinkWrapper from './PlayerLinkWrapper';

const CustomPlayerCell = (props) => {
    const { data = {} } = props;
    const { displayPositions, playerUrl, playerFullName, note, label, isSubstitute, type, playerId, language } = data;
    const NameWrapper = (!isSubstitute) ? InnerWrapper : SubstitutePlayerWrapper;

    return (
        <CustomPlayerCellContainer>
            <NameWrapper>
                {playerId
                    ? (
                        <PlayerLinkWrapper displayPositions={displayPositions} playerUrl={playerUrl} playerFullName={playerFullName} note={note} label={label} isSubstitute={isSubstitute} type={type} playerId={playerId} language={language}/>
                    )
                    : (
                        <PlayerNameWithNote player={label} note={note} type={type} />
                    )}
            </NameWrapper>
            <PositionWrapper>{displayPositions}</PositionWrapper>
        </CustomPlayerCellContainer>
    );
};

CustomPlayerCell.propTypes = {
    data: PropTypes.shape({
        displayPositions: PropTypes.string,
        playerUrl: PropTypes.string,
        playerFullName: PropTypes.string,
        note: PropTypes.string,
        player: PropTypes.string,
        isSubstitute: PropTypes.bool,
        type: PropTypes.string,
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        language: PropTypes.string,
        label: PropTypes.string
    })
};

export default CustomPlayerCell;
